import graphql__92832e61fd60552b2b95 from "./__generated__/ContributionsMapContributionsMarkersManager_participativeModule.graphql.js";
import graphql__e37c6260dd53b21f12de from "./__generated__/ContributionsMapContributionsMarkersManagerQuery.graphql.js";import { graphql, useFragment } from "react-relay";

import AppQueryRenderer from "../../../AppQueryRenderer";
import { BoxSpinner } from "../../../Utils/Spinner";
import ContributionsMapContributionsMarkers, {
  CONTRIBUTIONS_BATCH_SIZE
} from "./ContributionsMapContributionsMarkers";

const ContributionsMapContributionsMarkersManager = props => {
  const { visualization: map, slug: participativeModuleSlug } = useFragment(
    ContributionsMapContributionsMarkersManager_participativeModule,
    props.participativeModule
  );

  const contributionsCount = CONTRIBUTIONS_BATCH_SIZE;

  return (
    <AppQueryRenderer
      query={ContributionsMapContributionsMarkersManagerQuery}
      variables={{ participativeModuleSlug, contributionsCount }}
      component={ContributionsMapContributionsMarkers}
      loader={<BoxSpinner />}
      additionalProps={{ map }}
    />
  );
};

const ContributionsMapContributionsMarkersManager_participativeModule = graphql__92832e61fd60552b2b95;

const ContributionsMapContributionsMarkersManagerQuery = graphql__e37c6260dd53b21f12de;

export default ContributionsMapContributionsMarkersManager;
